import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader.tsx';
import { FieldBindingCanvas } from './FieldBindingCanvas/FieldBindingCanvas.tsx';
import type { RenderCanvasArgs } from './FieldBindingEditor.types.ts';

type Props = RenderCanvasArgs;

// Original mode drives the live, editable canvas; preview mode renders the
// generated PDF read-only (no bindings overlay — it's already resolved data).
export const EditorCanvasPane = ({
	isPreviewMode,
	isPreviewLoading,
	previewFileResponse,
	file,
	bindings,
	selectedFieldKey,
	setSelectedFieldKey,
	scale,
	onBoxChange,
	onAddBox,
	onRemove,
}: Props) => {
	if (!isPreviewMode) {
		return (
			<FieldBindingCanvas
				file={file}
				bindings={bindings}
				selectedFieldKey={selectedFieldKey}
				scale={scale}
				// The template, not a render: its leftover AcroForm values would print inside
				// the very boxes drawn over them.
				hidePrefilledFormValues
				onSelect={setSelectedFieldKey}
				onBoxChange={onBoxChange}
				onAddBox={onAddBox}
				onRemove={onRemove}
			/>
		);
	}

	if (isPreviewLoading || !previewFileResponse) {
		return <InlineLoader />;
	}

	return (
		<FieldBindingCanvas
			file={previewFileResponse}
			bindings={[]}
			selectedFieldKey={null}
			scale={scale}
			onSelect={() => undefined}
			onBoxChange={() => undefined}
			onAddBox={() => undefined}
			onRemove={() => undefined}
		/>
	);
};
